import { render, staticRenderFns } from "./PagesLinksListWidget.vue?vue&type=template&id=5051c914&scoped=true&"
import script from "./PagesLinksListWidget.vue?vue&type=script&lang=js&"
export * from "./PagesLinksListWidget.vue?vue&type=script&lang=js&"
import style0 from "./PagesLinksListWidget.vue?vue&type=style&index=0&id=5051c914&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5051c914",
  null
  
)

export default component.exports